import {fork} from 'redux-saga/effects';
import authWatcher from './auth/authWatcher';
import applicationWatcher from './application/applicationWatcher';
import invoiceSubmissionWatcher from './invoice-submission/invoiceSubmissionWatcher';
import serviceCasesWatcher from './service-case/serviceCasesWatcher';

// application sagas
export default [
    fork(authWatcher),
    fork(applicationWatcher),
    fork(invoiceSubmissionWatcher),
    fork(serviceCasesWatcher),
];
